var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7197 16.091C19.0126 16.3839 19.4874 16.3839 19.7803 16.091C20.0732 15.7981 20.0732 15.3232 19.7803 15.0303L12.25 7.5L4.71967 15.0303C4.42678 15.3232 4.42678 15.7981 4.71967 16.091C5.01256 16.3839 5.48744 16.3839 5.78033 16.091L12.25 9.62132L18.7197 16.091Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronup);
export default __webpack_public_path__ + "static/media/Chevron up.0f0452d7339561838b1a8c06963f7db1.svg";
export { ForwardRef as ReactComponent };